import * as ACTIONS from '../actions/app';

const INITIAL_STATE = {
    locale: document.documentElement.lang,
    modal: undefined,
    walkthrough: {
        openToolbar: false,
        running: false
    }
}

const reducer = ( state=INITIAL_STATE, action ) => {

    var walkthrough = { ...state.walkthrough };

    switch( action.type ){
        case ACTIONS.LOAD:
            return { ...state, view: action.payload };
        case ACTIONS.MODAL_TOGGLE:
            return { ...state, modal: action.payload };
        case ACTIONS.WALKTHROUGH_END:
            walkthrough = { ...INITIAL_STATE.walkthrough };
            return { ...state, walkthrough };
        case ACTIONS.WALKTHROUGH_START:
            walkthrough.running = true;
            return { ...state, walkthrough };
        case ACTIONS.WALKTHROUGH_TOOLBAR_CLOSE: 
            walkthrough.openToolbar = false;
            return { ...state, walkthrough };
        case ACTIONS.WALKTHROUGH_TOOLBAR_OPEN: 
            walkthrough.openToolbar = true;
            return { ...state, walkthrough };
        default:
            return { ...state };
    }
}

export default reducer;